import { render, staticRenderFns } from "./Comprehensive.vue?vue&type=template&id=2a836940&"
import script from "./Comprehensive.vue?vue&type=script&lang=js&"
export * from "./Comprehensive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports